export default {
    reservas: [],
    reservasNoConfirmada: []
}